'use strict';

import config from '../js/config';
import { runRequest } from '../utilities/makeRequest';

/**
 * BomApiEntry
 *
 * @typedef {Object} BomApiEntry
 * @property {string} bomId
 * @property {string} bomName
 * @property {string} description
 */

const BOM_REGION = 'NAC';


/**
 * List all designs for a user
 *
 * @returns {Promise.<BomApiEntry>}
 */
export function getBomsForUser() {
  return runRequest({
    url: `${config.urls.addToBomUser}`,
    dataType: 'json',
    xhrFields: {
      withCredentials: true
    }
  }).then(request => request.response.payload.map(bom => ({
    bomId: bom.bomId,
    bomName: bom.bomName,
    description: bom.description
  })));
}


/**
 * Create a new BOM
 *
 * @param {string} bomName
 * @returns {Promise.<BomApiEntry>}
 */
export function createBom(bomName, csrfToken) {
  return runRequest({
    url: `${config.urls.bom}`,
    method: 'post',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify({
      bomName: bomName,
      csrfToken: csrfToken
    }),
    xhrFields: {
      withCredentials: true
    }
  }).then(request => ({
    bomId: request.response.payload.bomId,
    bomName
  }));
}


/**
 * Add a part to a BOM
 *
 * @param {string} bomId
 * @param {string} partNumber
 * @param {string} manufacturerName
 * @param {number} quantity
 * @returns {Promise.<object>}
 */
export function addPartToBom(bomId, partNumber, manufacturerName, csrfToken, quantity = 1) {
  return runRequest({
    url: `${config.urls.bom}/${bomId}/rows`,
    method: 'post',
    contentType: 'application/json',
    dataType: 'json',
    data: JSON.stringify({
      partNumber: partNumber,
      manufacturer: manufacturerName,
      quantity: quantity,
      csrfToken: csrfToken
    }),
    //TODO: Remove timeout or use sitecore settings
    timeout: config.bomToolSettings.connectionTimeoutInMilliSeconds,
    xhrFields: {
      withCredentials: true
    },
    handleErrorLocally: true
  }).then(request => {
    if (request.response.status.statusCode !== 200) {
      throw new Error(request.response.status.statusMsg);
    }

    return request;
  }).then(request => request.response.payload);
}



// WEBPACK FOOTER //
// ./assets/services/BomService.js